import { gql } from '@apollo/client';

export const moodleSync = gql`
  mutation MoodleSync($input: MoodleSyncInput!) {
    moodleSync(input: $input) {
      url
    }
  }
`;

export const updateCourse = gql`
  mutation UpdateCourse($input: UpdateCourseInput!) {
    updateCourse(input: $input) {
      id
      shortId
      level
      integrity
      examTimeLimitSeconds
      archivedScheduledAt
      archivedAt
      archiveDate
      type
      domains {
        id
        name
      }
      name {
        value
        languageCode
      }
      episodes {
        id
        contentType
        status
        name {
          value
          languageCode
        }
        content {
          ... on Game {
            duration
            externalGameId
            type
          }
          ... on Videos {
            id
            duration
            videoFiles {
              key
            }
            file {
              processingStatus
            }
            subtitles {
              file {
                processingStatus
              }
              language {
                code
              }
            }
          }
        }
        attachments {
          id
          name {
            value
            languageCode
          }
          file {
            processingStatus
          }
        }
        ordinal
      }
      prerequisites {
        value
        languageCode
      }
      promoPicture {
        imageFiles {
          key
        }
        file {
          key
          processingStatus
        }
      }
      thumbnail {
        file {
          key
          processingStatus
        }
      }
      description {
        languageCode
        value
      }
      shortDescription {
        value
        languageCode
      }
      spokenLanguage {
        code
      }
      status
      trailer {
        id
        duration
        file {
          processingStatus
        }
        videoFiles {
          key
        }
        subtitles {
          file {
            processingStatus
          }
          language {
            code
          }
        }
      }
      typicalLearner {
        value
        languageCode
      }
      attachments {
        id
        file {
          processingStatus
        }
        name {
          value
          languageCode
        }
      }
      experts {
        id
        lastName
        firstName
        disabled
      }
      learningPoints {
        values
        languageCode
      }
      categories {
        ordinal
        name {
          value
          languageCode
        }
        id
      }
      catalogs {
        id
      }
      exam {
        ... on Test {
          id
          duration
          questions {
            question {
              value
              languageCode
            }
            answers {
              answer {
                languageCode
                value
              }
              correct
            }
          }
        }
        ... on Game {
          id
          externalGameId
          duration
        }
      }
    }
  }
`;

export const deleteCourse = gql`
  mutation DeleteCourse($id: ID!) {
    deleteCourse(id: $id) {
      id
    }
  }
`;

export const deletePublishedCourse = gql`
  mutation UpdateCourse($input: UpdateCourseInput!) {
    updateCourse(input: $input) {
      id
      status
      archivedAt
      archivedScheduledAt
      archiveDate
    }
  }
`;
